import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

import { AppService } from 'src/app/app.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';
import { OrderItemsDialogsService } from 'src/app/order-items/order-items-dialogs.service';
import { OrderItemsProcessService } from 'src/app/order-items/order-items-process.service';

import * as _ from 'lodash';

@Component({
    selector: 'app-order-items-summary',
    templateUrl: './order-items-summary.component.html',
    styleUrl: './order-items-summary.component.scss',
    standalone: false
})
export class OrderItemsSummaryComponent {
	$storage;
	basket;

	constructor(
		private _bottomSheetRef: MatBottomSheetRef<OrderItemsSummaryComponent>,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
		private router: Router,

		public appService: AppService,
		public dialogsService: DialogsService,

		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public orderDialogs: OrderItemsDialogsService,
		public orderProcess: OrderItemsProcessService,

	) {
		this.$storage = this.orderService.$storage;
		this.basket = this.$storage.basket;
		this.orderService.checkBasketAlcohol(this.$storage);
	}

	editOffer(offer) {
		this.orderDialogs.openOfferDialog(offer, true).then((result: any) => {
			if (result) {
				if (result.mode === 'delete') {
					this.deleteOfferCont(offer);
				}else {
					let index = this.basket.indexOf(offer);
					this.basket[index] = result["viewItem"];
					this.onChange();
				}
			}
		});
	}

	deleteOffer(offer, deleteAll?) {
		if (offer.quantity > 1 && !deleteAll && !offer._reserved?.benefitId && !offer.isLoyaltyOffer) {
			//this.loyaltyService.removeSingleBenfitFromOffer(this.$storage, offer);
			--offer.quantity;
			this.onChange();
			return;
		}
		let args: any;
		if (offer._reserved?.benefitId) {
			args = {
				"content": this.appService.translate("_LOYALTY.confirmDeleteOffer_reserved"),
				showCancelButton: true,
				confirmText: this.appService.translate("_LOYALTY_REG.removeOfferButton"),
				cancelText: this.appService.translate("_LOYALTY_REG.keepOfferButton")
			}
		}
		else if (offer.isLoyaltyOffer) {
			args = {
				"content": this.appService.translate("_LOYALTY_REG.confirmDeleteOffer"),
				showCancelButton: true,
				confirmText: this.appService.translate("_LOYALTY_REG.removeOfferButton"),
				cancelText: this.appService.translate("_LOYALTY_REG.keepOfferButton")
			}
		} else {
			args = {
				"content": this.appService.translate("TO.q_remove_offer_from_basket"),
				showCancelButton: true,
				confirmText: this.appService.translate("remove")
			}
		}
		this.appService.confirm(args).then(() => {
			if (offer._reserved) {
				if (offer._reserved?.benefitId) {
					//this.loyaltyService.cancelBenefitFromOffer(this.$storage, offer._reserved?.benefitId);
				}
			}
			this.deleteOfferCont(offer);
		});
	}
	deleteOfferCont(offer) {
		let index = this.basket.indexOf(offer);
		this.$storage.basket.splice(index, 1);
		//this.loyaltyService.getSelectedManualBenfitsCount(this.$storage);
		this.onChange(offer.isLoyaltyOffer ? 'deleteLoyaltyOffer' : 'deleteOffer');
		if (!this.$storage.basket.length) this.cancel();
	}

	duplicateOffer(offer) {
		this.orderService.validateOrderLimit(1, offer.total).then(() => {
			if (offer._reserved) {
				let newOffer = _.cloneDeep(offer);
				delete newOffer._reserved;
				newOffer._bid = this.orderUtils.getObjectId();
				newOffer.quantity = 1;
				this.$storage.basket.push(newOffer);
			} else {
				++offer.quantity;
			}
			this.onChange();
		});
	}

	onChange(args?) {
		this.orderService.calculateBasketTotal();
		this.orderService.checkBasketAlcohol(this.$storage);
	}

	async addItems() {
		try {
			await this.orderService.signInPrompt('addItems');
		} catch (err) {
			return;
		}

		this.appService.startBlock();
		try {
			const isPending = this.$storage.postPendingOffers
			const response = await this.orderProcess.addItemsToOrder(this.$storage, isPending);
			this.appService.stopBlock();
			this._bottomSheetRef.dismiss({redirect: 'order', isPending: isPending});
		} catch (err) {
			this.orderService.showOrderError(err?.error);
			this.appService.stopBlock();
		}
	}

	cancel() {
		this._bottomSheetRef.dismiss();
	}

}
